import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import tissue from "../../../../../assets/images/OUR SERVICES/5.tissue paper.png";
import EnquiryModal from '../../../../../common/pages/enquiryModal';
const TissuePaper = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Tissue Papers</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                <Col lg={6} md={12}>
                                    <img
                                        src={tissue}
                                        alt="Tissue Papers"
                                        className="img-fluid rounded"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12}>

                                    <div className="text-black">
                                        <p><strong>Multiline Tissue Papers</strong> – High-quality and soft tissue papers designed for office, hotel, and restroom use. Ideal for maintaining hygiene and comfort in professional spaces.</p>

                                        <p><strong>Limpiar Tissue Papers</strong> – Ultra-soft and highly absorbent tissues perfect for everyday use. Available in various sizes, including facial tissues, napkins, and toilet rolls.</p>

                                        <p><strong>Kimberly Clark Tissue Papers</strong> – A globally trusted brand offering premium-quality tissue products, including hand towels, facial tissues, and industrial wipes. Ideal for corporate offices, healthcare facilities, and hospitality sectors.</p>

                                        <p><strong>Greenline Tissue Papers</strong> – Environmentally friendly tissue papers made from sustainable materials. Designed to reduce carbon footprint while maintaining superior softness and durability. Perfect for eco-conscious businesses and individuals.</p>
                                    </div>
                                </Col>


                            </Row>
                        </Col>
                    </Row>
                </Container>
                <EnquiryModal isOpen={modal} toggle={toggleModal} />
            </section>
            <section className="section  py-5" style={{ backgroundColor: " rgb(52, 81, 159)" }} id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className='text-center '>
                            <Button className='px-4 py-2 fw-bold' onClick={toggleModal}
                                style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "20px" }}
                            >
                                Enquiry Now
                            </Button>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default TissuePaper;